import React from 'react';
import { Box } from '@mui/material';
import { EquipmentType, EQUIPMENT_TYPE_ICONS } from '../types/Equipment';

interface EquipmentTypeIconProps {
  type: EquipmentType;
  size?: number;
  framed?: boolean;
}

const EquipmentTypeIcon: React.FC<EquipmentTypeIconProps> = ({
  type,
  size = 32,
  framed = true,
}) => {
  const iconPath = EQUIPMENT_TYPE_ICONS[type] || EQUIPMENT_TYPE_ICONS.Other;
  const frameSize = Math.round(size * 1.35);

  if (!framed) {
    return (
      <Box
        component="img"
        src={iconPath}
        alt={type}
        sx={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: frameSize,
        height: frameSize,
        borderRadius: Math.max(12, Math.round(frameSize * 0.28)),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(160deg, rgba(0, 172, 193, 0.16) 0%, rgba(38, 166, 154, 0.22) 100%)',
        border: '1px solid rgba(0, 119, 190, 0.16)',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.28)',
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src={iconPath}
        alt={type}
        sx={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
      />
    </Box>
  );
};

export default EquipmentTypeIcon;